module.exports = __webpack_public_path__ + "img/Fake_Video-1.930cdac0.jpg";